import {CR_1_8} from "@/constants/crList"

export default CR_1_8
